const subscriptionPlansSwedish = {
  header: {
    title: "Välj din plan",
    description: "Få tillgång till alla funktioner och börja öka din LinkedIn-närvaro idag."
  },
  trial: {
    title: "14 dagars gratis provperiod",
    subtitle: "Ingen bindning - avsluta när som helst"
  },
  billing: {
    monthly: "Månadsvis",
    yearly: "Årligen",
    savingsLabel: "Spara 17%"
  },
  currency: {
    dkk: "DKK",
    usd: "USD"
  },
  plans: {
    basic: "Basic"
  },
  pricing: {
    perMonth: "månad",
    perYear: "år",
    monthly: "månad",
    yearly: "år"
  },
  quantity: {
    label: "Antal licenser:",
    seatsInfo: "Varje licens ger tillgång till 1 användare"
  },
  summary: {
    total: "Totalt:",
    checkoutButton: "Starta gratis provperiod"
  },
  errors: {
    checkoutError: "Ett fel uppstod vid skapande av checkout-session. Försök igen senare."
  }
};

export default subscriptionPlansSwedish;
